import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

import { ChipModule } from '@libs/src/chip/chip.module';
import { TextListModule } from '@libs/src/text-list/text-list.module';
import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { GroupSetDevelopmentGoalModule } from '@main-client/src/app/group-set-development-goal/group-set-development-goal.module';
import { IsAdminOfGroupPipeModule } from '@main-client/src/app/pipes/is-admin-of-group-pipe/is-admin-of-group-pipe.module';
import { TranslationLookupListModule } from '@main-client/src/app/pipes/translation-lookup-list/translation-lookup-list.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { PrivateSegmentsSelectionsModule } from '@main-client/src/app/private-segments-selections/private-segments-selections.module';
import { ProfileHubSettingsDialogModule } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.module';

import { ProfileMoreInfoComponent } from '@main-client/src/app/profile/profile-more-info/profile-more-info.component';

@NgModule({
  declarations: [ProfileMoreInfoComponent],
  exports: [ProfileMoreInfoComponent],
  imports: [
    ChipModule,
    CommonModule,
    FlexLayoutModule,
    GroupSetDevelopmentGoalModule,
    IsAdminOfGroupPipeModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    ProfileHubSettingsDialogModule,
    RouterModule.forChild([]),
    TextListModule,
    VisibleGroupsModule,
    NzCollapseModule,
    TranslationLookupModule,
    TranslationLookupListModule,
    PrivateSegmentsSelectionsModule,
  ],
})
export class ProfileMoreInfoModule {}
